import { render, staticRenderFns } from "./ListaConversas.vue?vue&type=template&id=4204846a&scoped=true"
import script from "./ListaConversas.vue?vue&type=script&lang=js"
export * from "./ListaConversas.vue?vue&type=script&lang=js"
import style0 from "./ListaConversas.vue?vue&type=style&index=0&id=4204846a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4204846a",
  null
  
)

export default component.exports